module.exports = __webpack_public_path__ + "static/media/settings.e1c0a314.svg";